module.exports = __webpack_public_path__ + "img/planet-venus-geology.061d1994.png";